import { type SbBlokData, storyblokEditable } from "@storyblok/js";
import { Slot } from "@trydig/ui";
import type { ComponentProps, PropsWithChildren } from "react";
import type { ISbComponentType } from "storyblok-js-client";

export interface BlokWrapProps extends ComponentProps<"div"> {
	// biome-ignore lint/suspicious/noExplicitAny: Storyblok component type is untyped
	editable: ISbComponentType<any>;
	as?: "div" | "section" | "article" | "main";
	asChild?: boolean;
	dataBlok?: boolean;
	"data-layout"?: string;
}

export const BlokWrap = ({
	children,
	editable,
	as: Component = "section",
	asChild,
	dataBlok,
	...rest
}: PropsWithChildren<BlokWrapProps>) => {
	const ComponentToUse = asChild ? Slot : Component;
	const props = {
		...rest,
		"data-blok": dataBlok ? true : undefined,
		"data-blok-name": process.env.NODE_ENV === "development" ? editable.component : undefined,
	};

	return (
		<ComponentToUse {...storyblokEditable(editable as SbBlokData)} {...props}>
			{children}
		</ComponentToUse>
	);
};
